import * as z from "zod/v4";

export const prepareKlaviyoFlows = {
  name: "prepareKlaviyoFlows" as const,
  input: z.object({
    flowIds: z.array(z.string()),
    splitId: z.string(),
    variantBuckets: z.array(z.number()).optional(),
  }),
  output: z.object({
    duplicatedFlowIds: z.array(z.string()),
    tagId: z.string(),
    skippedFlowIds: z.array(z.string()),
  }),
};
